import { memo } from 'react';
import { useBluPopupNotification } from './PopupNotificationContext';
import { Stack } from '@mui/material';
import { NotificationItem } from './NotificationItem';

export const BluPopupNotification = memo(() => {
  const { notifications } = useBluPopupNotification();
  if (notifications.length === 0) return null;
  return (
    <Stack
      spacing={2}
      sx={{
        position: 'fixed',
        top: 60,
        right: 5,
        zIndex: 1300,
      }}
    >
      {notifications.map((notification) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}
    </Stack>
  );
});
